import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { hasPemissions } from '../../../commons/utils';
import { mtDividerUpTable } from '../../../commons';
import { CreateEditRuleModal } from './modals/CreateEditRuleModal';
import { BannerInfoReglasProgramacion } from './components/BannerInfoReglasProgramacion';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../commons/texts';
import { TableReglasProgramacionPorCargo } from './components/TableReglasProgramacionPorCargo';

export const ReglasProgramacionPorCargo = () => {
  // States for Modals and Forms
  const [openModalForm, setOpenModalForm] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedRule, setSelectedRule] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [hasPermission, setHasPermission] = useState(true);
  const [canEdit, setCanEdit] = useState(false);

  const checkPermissions = async () => {
    const view = await hasPemissions(
      'modulo.thumano',
      'modulo.programador',
      'view',
      'modulo.programador.reglas'
    );
    if (!view) {
      setHasPermission(false);
    }

    const edit = await hasPemissions(
      'modulo.thumano',
      'modulo.programador',
      'edit',
      'modulo.programador.reglas'
    );
    if (edit) setCanEdit(true);
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const handleCreate = () => {
    setSelectedRule(null);
    setIsViewMode(false);
    setOpenModalForm(true);
  };

  const handleView = (rule: any) => {
    setSelectedRule(rule);
    setIsViewMode(true);
    setOpenModalForm(true);
  };

  const handleEdit = (rule: any) => {
    setSelectedRule(rule);
    setIsViewMode(false);
    setOpenModalForm(true);
  };

  const reloadData = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  if (!hasPermission) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="textSecondary">
          No tienes permisos para ver este contenido.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <BreadCrumbsAndTitle
            title="Reglas de Programación por Cargo"
            mainModule="Programador Inteligente"
            parent="Reglas de programación"
            action=""
            icon="Rule"
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <AlertsInformativos
              type={'info'}
              title={'info'}
              content={alertInformativo.reglasProgramacion}
            />
          </Typography>
        </Box>
        {canEdit && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleCreate}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)',
            }}
          >
            Nueva Regla
          </Button>
        )}
      </Box>

      <Divider sx={{ marginBottom: mtDividerUpTable }} />

      <TableReglasProgramacionPorCargo
        onEdit={handleEdit}
        onView={handleView}
        refreshDataTrigger={refreshTrigger}
      />

      {openModalForm && (
        <CreateEditRuleModal
          open={openModalForm}
          setOpen={(val: boolean) => {
            setOpenModalForm(val);
            if (!val) setSelectedRule(null);
          }}
          isViewMode={isViewMode}
          item={selectedRule}
          reloadTable={reloadData}
        />
      )}

      <Box sx={{ mt: 4 }}>
        <BannerInfoReglasProgramacion />
      </Box>
    </Box>
  );
};
